import styles from "@coworker/apprestructured/src/media-maintenance/styles/common-media-styles.module.css";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import {
  EdsData,
  SalesStopData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { TaskLinks } from "@coworker/app/src/components/RoomSettings/types/taskLink";
import { useTranslation } from "@coworker/locales";
import { getMediaItemBadges } from "@coworker/apprestructured/src/media-maintenance/helpers/getMediaItemBadges";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { ItemListViewItemCard } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemListViewItemCard/ItemListViewItemCard";
import { MediaItemType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemType";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";
import { Item } from "@coworker/apprestructured/src/shared/types/item";

interface AggregatedItemsListViewProps {
  article: AggregatedArticle;
  media: Media;
  taskLinks: TaskLinks;
  mediaItemType?: MediaItemType;
  salesStopData?: SalesStopData | null;
  edsData?: EdsData | null;
  selectArticleIdsMode?: boolean;
  isSelected?: boolean;
  handleSelectedItemChange?: () => void;
  itemCardRenderType?: ItemCardRenderType;
  itemInfo: Item | null;
  itemInfoLoading: boolean;
}

export const AggregatedItemListViewItem = ({
  article,
  media,
  taskLinks,
  mediaItemType = MediaItemType.REGULAR_ITEM,
  salesStopData,
  isSelected,
  edsData,
  selectArticleIdsMode = false,
  handleSelectedItemChange,
  itemCardRenderType = ItemCardRenderType.link,
  itemInfo,
  itemInfoLoading,
}: AggregatedItemsListViewProps) => {
  const isItemInGroups = article.aggregatedArticles.some((a) => a.groupId);

  const { t } = useTranslation();
  const badges = getMediaItemBadges(
    article.id,
    article.aggregatedArticles.map((a) => a.id),
    t,
    taskLinks,
    salesStopData,
    media,
    true
  );

  mediaItemType = article.parentArticleCombinationNumber
    ? MediaItemType.LC_SUBITEM
    : mediaItemType;

  return (
    <div
      className={
        selectArticleIdsMode
          ? styles["item-card-root-row"]
          : styles["list-view-item-root"]
      }
    >
      <div
        className={
          selectArticleIdsMode
            ? styles["item-card-root-column"]
            : styles["list-view-item-root"]
        }
      >
        <ItemListViewItemCard<AggregatedArticle>
          edsData={edsData ?? null}
          mediaItemType={mediaItemType}
          selectArticleIdsMode={selectArticleIdsMode}
          itemCardRenderType={itemCardRenderType}
          isItemInGroups={isItemInGroups}
          badges={badges}
          article={article}
          media={media}
          mediaItemViewType={MediaItemViewType.AGGREGATED_ITEM_VIEW}
          itemInfo={itemInfo}
          itemInfoLoading={itemInfoLoading}
        />
      </div>
      {selectArticleIdsMode && (
        <div
          className={styles["select-item-checkbox"]}
          data-testid={`select-article-checkbox-aggregated`}
        >
          <FixaCheckbox
            id={article.id}
            value={article.id}
            checked={isSelected || false}
            onChange={handleSelectedItemChange || (() => {})}
          />
        </div>
      )}
    </div>
  );
};
